import { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, apiErrorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SEO } from "@/components/SEO";

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const { refreshMe } = useAuth();
  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("");
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    if (!token) {
      setStatus("error");
      setMessage("Missing verification token.");
      return;
    }
    api
      .post("/auth/verify-email", { token })
      .then(() => {
        setStatus("success");
        refreshMe();
      })
      .catch((e) => {
        setStatus("error");
        setMessage(apiErrorMessage(e));
      });
  }, [token, refreshMe]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="verify-email-page">
      <SEO title="Verify Email | A8A" description="Confirm your A8A account email address." noindex />
      <div className="max-w-sm text-center space-y-4">
        {status === "verifying" && (
          <p className="text-sm text-muted-foreground" data-testid="verify-email-loading">
            Verifying your email&hellip;
          </p>
        )}
        {status === "success" && (
          <>
            <h1 className="font-heading text-2xl text-foreground">Email Verified</h1>
            <p className="text-sm text-muted-foreground" data-testid="verify-email-success">
              Your email address has been confirmed.
            </p>
            <Link to="/dashboard" className="text-sm underline text-foreground" data-testid="verify-email-dashboard-link">
              Go to Dashboard &rarr;
            </Link>
          </>
        )}
        {status === "error" && (
          <>
            <h1 className="font-heading text-2xl text-foreground">Verification Failed</h1>
            <p className="text-sm text-destructive" data-testid="verify-email-error">{message}</p>
            <Link to="/dashboard" className="text-sm underline text-foreground" data-testid="verify-email-dashboard-link">
              Go to Dashboard &rarr;
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
